var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "#FFF",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "CloseIcon_svg__a",
    d: "M11.535 8l3.098-3.1a1.252 1.252 0 000-1.77l-1.769-1.77a1.268 1.268 0 00-1.769 0l-3.099 3.1-3.089-3.1a1.268 1.268 0 00-1.769 0L1.36 3.13a1.27 1.27 0 000 1.77L4.458 8l-3.089 3.1a1.252 1.252 0 000 1.77l1.77 1.77c.478.48 1.28.48 1.768 0l3.09-3.1 3.098 3.1c.489.48 1.28.48 1.77 0l1.768-1.77a1.252 1.252 0 000-1.77L11.535 8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "fill",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "CloseIcon_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CloseIcon_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CloseIcon_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#CloseIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCloseIcon;